var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyrcene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#DA6756;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.6,353.2h6.6l10.1,18.8h0.1l10.1-18.8h6.6v33h-6.5v-20.4h-0.1l-8,14.2h-4.2l-8-14.2h-0.1v20.5h-6.5V353.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188,371.7l-10.9-18.5h7.5l6.7,12h0.1l6.6-12h7.6l-11,18.5v14.5H188V371.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.6,353.2h12.5c8,0,11.5,4.7,11.5,11c0,5-2.3,8.5-6.9,10l8.3,12.1h-7.8l-7.4-11.3h-3.8v11.3h-6.5V353.2z  M220.8,369.2c4,0,6-2,6-5.1c0-3.1-2-5.1-5.8-5.1h-5v10.1H220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.6,369.8c0-9.4,6-17,16.7-17c4.7,0,9.6,2,13.2,6.4l-4.8,4c-2.1-2.6-4.9-4.2-8.3-4.2 c-5.6,0-9.9,4.2-9.9,10.8c0,6.1,4.1,10.6,10,10.6c3.4,0,6.3-1.7,8.3-4.2l4.8,4.1c-2.8,3.5-7.3,6.2-13.1,6.2 C245.3,386.6,237.6,380.7,237.6,369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.6,353.2h21.1v5.8H279v8h11.7v5.7H279v7.7h15.6v5.8h-22.1V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.4,353.2h6.4l14.8,22.3h0.1v-22.3h6.5v33h-6.6L307,364.4h-0.1v21.8h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.4,353.2h21.1v5.8h-14.7v8h11.7v5.7h-11.7v7.7h15.6v5.8h-22.1V353.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.3,151h-4.8v39.8h5.4c2.4,0,3.6-2.3,3.6-7v-25.4c0-2.6-0.4-4.5-1.2-5.7C296.5,151.6,295.5,151,294.3,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.6,98.8c-54.4,0-98.4,44.1-98.4,98.4s44.1,98.4,98.4,98.4s98.4-44.1,98.4-98.4S302,98.8,247.6,98.8z  M225.9,246.5h-8.3v-73.1h-0.1l-8.2,73.1h-7.4l-8.2-73.1h-0.2v73.1H185v-104h13.1l7.3,65.7h0.2l7.4-65.7h12.9V246.5z M257.7,207.5 v38.9h-10.1v-38.9l-11.2-65h10l6.1,42.1h0.3l6.1-42.1h10L257.7,207.5z M300.1,246.5c-0.7-1.2-1.1-3.2-1.3-5.9 c-0.2-2.8-0.3-6.7-0.3-11.7v-23.3c0-4.8-1.2-7.1-3.6-7.1h-5.4v48.2h-10.1V142.5h15.9c3.6,0,6.7,1.2,9.3,3.6c2.6,2.4,3.9,6,3.9,10.8 v27.5c0,3.2-0.5,5.5-1.5,7.1c-1,1.5-2.2,2.6-3.7,3c1.5,0.4,2.7,1.4,3.7,2.9s1.5,3.9,1.5,7.1v24.2c0,6.2,0.2,10.6,0.6,13.2 c0.4,2.5,0.7,4,1,4.5L300.1,246.5L300.1,246.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyrcene);
export default __webpack_public_path__ + "static/media/MYRCENE.8c17590cdc2cc58d72b3557fec87af09.svg";
export { ForwardRef as ReactComponent };